import { RestProvider } from '../../providers/rest/rest';
import { Component, Input, NgZone } from "@angular/core";
import { IonicPage, NavParams, NavController, ModalController, AlertController, LoadingController, Platform, ToastController } from 'ionic-angular';
import { OrdersProvider } from '../../providers/orders/orders';
import { AuthProvider } from '../../providers/auth/auth';
import {FileUploader, FileUploaderOptions, ParsedResponseHeaders} from 'ng2-file-upload';
//import { LoginPage } from '../login-page/login-page';
import { Storage } from '@ionic/storage';
import { GlobalProvider } from "../../providers/global/global";
import moment from 'moment';
/**
 * Generated class for the OrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
    segment: 'stream'
})
@Component({
  selector: 'page-stream',
  templateUrl: 'stream.html',
})
export class StreamPage {

	orders: any;
  stats:any;
	max_width:number = 100;

  search_Order_Id: string;
  search_User_Id: string;
  search_Status: any;
  search_Internal_Status: any;
  search_Image_Internal_Status:any;
  sort_orders_created_by:any;
  search:string;
  searchField:string;
  limit:number;
  //Show full image quality size (publishable_file_url), else show thumb
  is_full_resolution:boolean;


  public date: any;

  //Pagination
  res: any; //Pagination data
  // p: number = 1; //Pagination page
  //@Input('data') orders: string[] = [];
    //asyncMeals: Observable<string[]>;
    p: number = 1;
    per_page: number;
    total: number;
    //loading: boolean;
    uploader: FileUploader;
    uploadImageType:any;
    forImageId:any;
    responses: Array<any>;
    imageSwatch:any;
    hasBaseDropZoneOver: boolean;

  loader: boolean;
  loading: any;
	errorMessage: string;
  public devWidth = this.platform.width(); //returns screensize

  constructor(public navCtrl: NavController, public navParams: NavParams, public rest: RestProvider, 
    public orderService: OrdersProvider, public modalCtrl: ModalController,
    public alertCtrl: AlertController, public authService: AuthProvider, public loadingCtrl: LoadingController, 
    public platform: Platform, public toastCtrl: ToastController, public storage: Storage ,
    public global: GlobalProvider, private zone: NgZone) {
  	this.date = moment();
  }

  resetSearchFilters(){
    this.search = '';
    this.search_Status = 'all';
    this.search_Internal_Status = 'all';

  }

  setSearchFilter(type:string){

    this.resetSearchFilters();

    if (type == 'orders_need_approval') {
      this.search_Internal_Status = 20;
    }

    if (type == 'orders_need_spec_translation') {
      this.search_Internal_Status = 10;
    }

    if (type == 'orders_in_production') {
      this.search_Status = 50;
      this.search_Internal_Status = 100;
    }

    if (type == 'orders_complete') {
      this.search_Status = 100;
      this.search_Internal_Status = 100;
      console.log(this.search_Status, this.search_Internal_Status);
    }

    this.getPage(1);
   
  }

  ionViewDidLoad() {

    this.responses = [];

    // Default order created_at sort order
    this.sort_orders_created_by = 'desc';

    // Drfault search or order_id
    this.searchField = 'id';
    this.limit = 10;
    
    this.getPage(1);

    this.storage.get('token').then((token) => {

            const uploaderOptions: FileUploaderOptions = {            
                    url: this.global.apiUrl + 'upload-image',
                    autoUpload: true,
                    isHTML5: true,
                    removeAfterUpload: true,
                    headers: [
                        {
                            name: 'X-Requested-With',
                            value: 'XMLHttpRequest'
                        },
                        {
                            name: 'Authorization',
                            value: 'Bearer ' + token
                        }
                    ]
                };
                this.uploader = new FileUploader(uploaderOptions);

                // Add custom tag for displaying the uploaded photo in the list
                this.uploader.onBuildItemForm = (fileItem: any, form: FormData): any => {
                    //this.showLoader();
                    this.showSimpleLoader();
                    //form.append('upload_preset', this.cloudinary.config().upload_preset);
                    //let tags = 'myphotoalbum';
                    form.append('uploadImageType', this.uploadImageType);
                    form.append('image_id', this.forImageId);
                    if (this.imageSwatch) {
                      form.append('swatch_type', this.imageSwatch.type);
                      form.append('swatch_value', this.imageSwatch.value);
                    }
                    
                    //form.append('tags', tags);
                    console.log('FILE ITEM', fileItem);
                    form.append('file', fileItem);

                    fileItem.withCredentials = false;
                    return { fileItem, form };
                };

                // Insert or update an entry in the responses array
                const upsertResponse = fileItem => {

                    // Run the update in a custom zone since for some reason change detection isn't performed
                    // as part of the XHR request to upload the files.
                    // Running in a custom zone forces change detection 
                    
                    this.zone.run(() => {
                        // Find the id of an existing item
                        const existingId = this.responses.reduce((prev, current, index) => {
                            if (current.file.name === fileItem.file.name && !current.status) {
                                console.log('Index:', index);
                                console.log(this.responses);
                                return index;
                            }
                            return prev;
                        }, -1);
                        if (existingId > -1) {
                            // Update existing item with new data
                            this.responses[existingId] = Object.assign(this.responses[existingId], fileItem);
                        } else { 
                            // Create new response
                            this.responses.push(fileItem);                    
                        }
                    });
                };

                this.uploader.onCompleteItem = (item: any, response: string, status: number, headers: ParsedResponseHeaders) =>


                 {

                            var imageResponse = JSON.parse(response);
                            //console.log('ITEM:::::::', item);
                            console.log('RESPONSE:::', imageResponse);
                            // Check if upload was of type add-on or type main
                            if(imageResponse.success){
                                let toast = this.toastCtrl.create({
                                    message: imageResponse.message,
                                    duration: 2000,
                                    position: 'bottom'
                                  });
                                toast.present();
                                
                                let image = imageResponse.data.image;

                                //Update image locally
                                  let index = this.orders[0].images.findIndex(item => item.id == image.id);
                                  if (index !== -1) {
                                   this.orders[0].images[index] = image;
                                  }

                                // Check if image was last image of images
                                console.log("IMAGES::::", this.orders[0].images);

                                

                                if (this.uploadImageType == 'main') {
                                  let openImages = this.orders[0].images.filter(item => item.status < 100);
                                  console.log("OPEN IMAGES:", openImages);
                                  if (openImages.length == 0) {
                                    this.completeOrder(this.orders[0]);
                                    this.fireCompleteOrderNotification();
                                  }
                                }

                                // if (this.uploadImageType == 'add-on') {
                                //   let image = imageResponse.data;

                                //   // Update image locally
                                //   let index = this.images.findIndex(item => item.id == image.id);
                                //   if (index !== -1) {
                                //    this.images[index] = image;
                                //   }

                                //   console.log("Add On Upload Result", imageResponse);
                                // }else{
                                //   this.images.push(imageResponse.data);
                                // }
                                
                                  
                            }else{
                              //Response error
                              this.fireAlert(imageResponse.message);
                              console.log('Response Error!', imageResponse);
                            }

                            //console.log(this.images);


                            upsertResponse(
                            {
                                file: item.file,
                                status,
                                data: JSON.parse(response)
                            }
                        );
                  };


                this.uploader.onProgressItem = (fileItem: any, progress: any) =>
                    upsertResponse(
                        {
                            file: fileItem.file,
                            progress
                        }
                    );

                this.uploader.onCompleteAll = () => {
                    if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                    this.closeSimpleLoader();

                    this.loading = null;
                  };
                //this.uploader.onCompleteAll = (item: any) => this.loading.dismiss();
        });
    


    //this.getOrders();
    //console.log("Orders:");
    //console.log(this.orders);
  }


  refreshOrders() {
    this.getPage(1);
  }

  searchEnter(ev){
  	this.getPage(1);
  }

  getPage(page: number) {
    let searchOrderId = this.search_Order_Id;

    this.showLoader(); 
    this.orderService.getStreamOrders(page, searchOrderId, this.search_Status, this.search_Internal_Status, this.sort_orders_created_by, this.search, this.searchField, this.limit, this.search_Image_Internal_Status).then((data: any) => {
        console.log('DATAA from Page:', data);
          this.res = data;
          this.orders = data.data;
          

          this.total = this.res.total;
          this.per_page = this.res.per_page;
          this.p = this.res.current_page;

          const perPage = 10;
          const start = (page - 1) * perPage;
          const end = start + perPage;

          if(this.loading){ this.loading.dismiss(); this.loading = undefined };
          this.closeSimpleLoader();

          this.getStreamStats();

    }, (err) => {
        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        this.closeSimpleLoader();
        this.fireToast(err.json().error);
        console.log("not allowed_____");
        console.log(err);
    });


    }

  getStreamStats() {
 
    this.orderService.getStreamStats().then((data: any) => {
        console.log('DATAA from getStreamStats:', data);

          this.stats = data;
          

    }, (err) => {

        this.fireToast(err.json().error);
        console.log("not allowed_____");
        console.log(err);
    });


    }

  formatUTC(date){
    return moment.utc(date).local().format('D.MM.YYYY');
  }

  pageChanged(event){
    this.getPage(event);
  }

  openOrderManager(order_id){
    const modal: any = this.modalCtrl.create('OrderManagerPage', { order_id: order_id });
    modal.present(); 
  }

  openOrderInCrm(orderId:number) {
    this.navCtrl.push('CrmPage', {
      orderId: orderId
    })
  }

  openUserInCrm(userId:number) {
    this.navCtrl.push('CrmPage', {
      userId: userId
    })
  }

  openTranslateRejections() {
    this.navCtrl.push('TransRejectionPage')
  }

  fireCompleteOrderNotification() {
    this.fireToast("Looks like all images have been completed. Please don't forget to press the 'Complete' button");
  }

  saveSpecsTranslation(order){
    this.orderService.completePreProcessing(order).then((data: any) => {
        console.log('DATAA from COMPLETE ORDER:', data);
          this.fireToast(data.message);
          let index = this.orders.findIndex(item => item.id == order.id);
          if(index > -1){
            //Remove locally
              this.orders.splice(index, 1);
          }     
    }, (err) => {
        console.log("Error in Order completion", err);
        this.fireToast(err.json().message);
    });
  }

  blockOrder(order){
                    this.orderService.blockOrder(order).then((data: any) => {
                        console.log('DATAA from COMPLETE ORDER:', data);
                          this.fireToast(data.message);
                          this.orders[0].is_blocked_by_admin = true;

                    }, (err) => {
                        
                        console.log("Error in Order completion", err);
                        this.fireToast(err.json().message);
                    });
  }

  completeOrder(order){

     let prompt = this.alertCtrl.create({
      title: "Complete order",
      message: "All images done ? Order will disappear from backend after completion.",
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Complete",
          handler: complete => { 
                    this.showLoader();
                    this.orderService.completeOrder(order).then((data: any) => {
                        console.log('DATAA from COMPLETE ORDER:', data);
                          this.fireToast(data.message);
                          if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                          this.getPage(1);

                    }, (err) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        console.log("Error in Order completion", err);
                        this.fireToast(err.json().message);
                    });
          }
        }
      ]
    });
 
    prompt.present();



    



  }

  setMaxWidth(max_width:number){
  	this.max_width = max_width;
  }

  getStatsBadgeColor(val:number){
    if (val > 0) {
      return 'danger';
    }
    return 'secondary';
  }

  getInternalStatusColor(status: number) {
    if(status == 100){ // Ready, but delivery failed
      return 's_light_green';
    }
    if(status == 50){
      return 'danger';
    }
    return 'primary';
    
  }

  getStatusColor(status: number) {
    if(status == 110){ // Ready, but delivery failed
      return 'dark';
    }
    if(status == 100){
      return 's_light_green';
    }
    if(status == 50){ // In Production
      return 'light';
    }
    if(status == 40){ //Waiting for payment
      return 'danger';
    }
    if(status == 10){ //Ready for production
      return 'orange';
    }
    if(status == 500){ // Archived
      return 'primary';
    }
    
    return 'primary';
    
  }

  operatorRejectOrder(order:any){
  	console.log("Reject order:", order);
  	let prompt = this.alertCtrl.create({
      title: "Order had rejections by operator",
      message: "Are you sure ? Job will be send back into prodution",
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Reject",
          handler: rejection => {
 				console.log("REJECTION:", rejection);
                    this.showLoader();
                    this.orderService.rejectOperatorOrder(order).then((result: any) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireToast(result.message);

                        //Update locally
                         let index = this.orders.findIndex(item => item.id == order.id);
                          console.log("INDEX OF Order:", index);                       
				            if(index > -1){
				            	//Remove locally
				                this.orders.splice(index, 1);
				                
				            }     
                        
                    }, (err) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireAlert(err.json().message);
                        console.log("not allowed");
                    }); 
 
          }
        }
      ]
    });
 
    prompt.present();
  }

  operatorApproveOrder(order:any){
  	console.log("Approve order:", order);
  	this.showLoader();
    this.orderService.approveOperatorOrder(order).then((result: any) => {
        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        this.fireToast(result.message);

        //Update locally
         let index = this.orders.findIndex(item => item.id == order.id);
          console.log("INDEX OF Order:", index);                       
            if(index > -1){
            	//Remove locally
                this.orders.splice(index, 1);
                
            }     
        
    }, (err) => {
        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        this.fireAlert(err.json().message);
        console.log("not allowed");
    }); 
  }

  operatorRejectImage(order:any, image:any){
 
    let prompt = this.alertCtrl.create({
      title: "Image rejection",
      message: "Are you sure ?",
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Reject",
          handler: rejection => {
 				console.log("REJECTION:", rejection);
                    this.showLoader();
                    this.orderService.rejectOperatorImage(image).then((result: any) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireToast(result.message);

                        //Update locally
                        let image = result.data;
                        
                        
                         let index = order.images.findIndex(item => item.id == image.id);
                          console.log("INDEX OF IMAGE:", index);                       
				            if(index > -1){
				            	//Remove locally
				                //order.images.splice(index, 1);
				                
				                // Update locally
				                order.images[index] = image;
				                
				            }     

				         // Update order locally
				         let index2 = this.orders.findIndex(item => item.id == order.id);
				         console.log("INDEX of ORDER:", index2);
				         if (index2 !== -1) {
				         	console.log("REPLACE OLD ORDER BY NEW");
                         this.orders[index2] = order;
                        }	
				         
                        
                        
                        //let index = order.images.findIndex(item => item.id == image.id);
                        //let index = this.images.findIndex(item => item.id == image.id);
                        

                        
                    }, (err) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireAlert(err.json().message);
                        console.log("not allowed");
                    }); 
 
          }
        }
      ]
    });
 
    prompt.present();
 
  }

  // rejectImage(image){
 
  //   let prompt = this.alertCtrl.create({
  //     title: this.translate.instant("ORDER.REJECT_IMAGE_TITLE"),
  //     message: this.translate.instant("ORDER.REJECT_IMAGE_DESC"),
  //     inputs: [
  //       {
  //         name: 'disapproved_text'
  //       }
  //     ],
  //     buttons: [
  //       {
  //         text: this.translate.instant("BUTTONS.CANCEL")
  //       },
  //       {
  //         text: this.translate.instant("BUTTONS.SAVE"),
  //         handler: rejection => {
 
  //               if(rejection){
 
  //                   this.showLoader();
  //                   image.disapproved_text = rejection.disapproved_text;
  //                   this.orderService.rejectAdminImage(image).then((result: any) => {
  //                       if(this.loading){ this.loading.dismiss(); this.loading = undefined };
  //                       this.fireAlert(result.message);
  //                       console.log('Disapproval result', result);
  //                       //Update locally

                        
  //                   }, (err) => {
  //                       if(this.loading){ this.loading.dismiss(); this.loading = undefined };
  //                       this.fireAlert(err.json().message);
  //                       console.log("not allowed");
  //                   });
 
  //               }
 
 
  //         }
  //       }
  //     ]
  //   });
 
  //   prompt.present();
 
  // }


  changeUploadImageType(type, image, swatch){
    this.uploadImageType = type;
    console.log('SWATCH', swatch);
    if (swatch) {
      this.forImageId = image.id;
      this.imageSwatch = swatch;
    }else{
      this.forImageId = image.id;
    }
    console.log('this.uploadImageType', this.uploadImageType);
    console.log('this.forImageId', this.forImageId);
    console.log('this.image_swatch', this.imageSwatch);
  }

  showSimpleLoader(){
    this.loader = true;
  }

  closeSimpleLoader(){
    this.loader = false;
  }

  showLoader(){
 
    this.loading = this.loadingCtrl.create({
      content: 'Loading...'
    });
 
    this.loading.present();
 
  }
 
  logout(){
 
    this.authService.logout();
    this.navCtrl.setRoot('LoginPage');
 
  }

  open_help(type:string){
    if (type == 'free_image') {
      this.fireAlert('This image can be rejected with the reason "Too Difficult" if it is obvious that it is not a proper product photo. (Animals, People, Stock Photos, Sketches, Paintings)');
    }
  }

  fireToast(message: string) {
    console.log('fire toast!');
    let toast = this.toastCtrl.create({
                                    message: message,
                                    duration: 3000,
                                    position: 'bottom'
                                  });
                toast.present();
  }

  fireAlert(message: string) {
    let alert = this.alertCtrl.create({
                                    message: message,
                                    //duration: 2000,
                                    //position: 'bottom'
                                  });
    alert.present();
  }

  public fileOverBase(e: any, type:string, image:any, swatch:any): void {
        this.hasBaseDropZoneOver = e;

            this.uploadImageType = type;
            if (swatch) {
              this.forImageId = image.id;
              this.imageSwatch = swatch
            }else{
              this.forImageId = image.id;
            }
            console.log('this.uploadImageType', this.uploadImageType);
            console.log('this.forImageId', this.forImageId);
            console.log('this.image_swatch', this.imageSwatch);
  }

}



// WEBPACK FOOTER //
// ./src/pages/stream/stream.ts